export const animateAll = 'transition-all ease-in duration-300';
export const animateColors = 'transition-colors ease-in duration-300';
export const animateOpacity = 'transition-opacity ease-in duration-300';
export const animateTransform = 'transition-transform ease-in duration-300';
